'use client';

import { PropsWithChildren, ReactElement } from 'react';

import { SkeletonThemeContext } from './SkeletonThemeContext';
import { SkeletonStyleProps } from './types';

export type SkeletonThemeProps = PropsWithChildren<SkeletonStyleProps>;

const SkeletonTheme = ({
  children,
  ...styleOptions
}: SkeletonThemeProps): ReactElement => (
  <SkeletonThemeContext value={styleOptions}>{children}</SkeletonThemeContext>
);

export default SkeletonTheme;
